import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import rulePopout from 'components/triggers/RulePopout';
import CrmSelection from './CrmSelection';
import CrmAccountActions from 'actions/crm-opp-ui/CrmAccountActions';
import FlatButton from 'components/pure/utils/FlatButton';
import CrmOpportunityActions from 'actions/crm-opp-ui/CrmOpportunityActions';
import CrmContactActions from 'actions/crm-opp-ui/CrmContactActions';
import CrmOpportunityStore from 'stores/crm-opp-ui/CrmOpportunityStore';
import {CallConditionType} from 'records/CallTrigger';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import CrmAccountStore from 'stores/crm-opp-ui/CrmAccountStore';
import CrmContactStore from 'stores/crm-opp-ui/CrmContactStore';

class CrmSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.selectedContextTypeChanged = this.selectedContextTypeChanged.bind(this);
    this.selectedValueChanged = this.selectedValueChanged.bind(this);

    this.state = {};
  }

  static getStores() {
    return [CrmOpportunityStore];
  }

  static getPropsFromStores(nextProps) {
    const opportunityState = CrmOpportunityStore.getState();
    const stages = opportunityState.stages || [];
    const stageOptions = stages.map(stage => {
      return {label: `${stage.crmName} - ${stage.clientName}`, value: stage.id};
    });

    return {stageOptions};
  }

  componentDidMount() {
    const {selectedValue, selectedContextType} = this.props;
    CrmOpportunityActions.fetchStages();

    if (selectedContextType === CallConditionType.FOR_OPPORTUNITY) {
      const opportunity = CrmOpportunityStore.getState().opportunities.get(selectedValue);
      opportunity && CrmOpportunityActions.setSearchTerm(opportunity.name);
    } else if (selectedContextType === CallConditionType.TO_ACCOUNT) {
      const account = CrmAccountStore.getState().accounts.get(selectedValue);
      account && CrmAccountActions.setSearchTerm(account.name);
    } else if (selectedContextType === CallConditionType.WITH_CONTACT) {
      const contact = CrmContactStore.getState().contacts.get(selectedValue);
      contact && CrmContactActions.setSearchTerm(contact.name);
    }

    this.setState({
      context: CallConditionType.getCallCondition({
        type: selectedContextType,
        value: selectedValue,
      }),
    });
  }

  selectedContextTypeChanged(type) {
    const context = this.state.context;
    if (!context || context.type !== type) {
      this.setState({
        context: CallConditionType.getCallCondition({type}),
      });
    }
  }

  componentWillUnmount() {
    CrmAccountActions.clearSearch();
    CrmOpportunityActions.clearSearch();
    CrmContactActions.clearSearch();
  }

  selectedValueChanged(value) {
    const type = this.state.context.type;
    const context = CallConditionType.getCallCondition({type, value});
    this.setState({
      context,
    });
    if (this.props.saveOnSelect) {
      this.saveSelection(context);
    } else {
      this.updateSelection(context);
    }
  }

  updateSelection(context) {
    this.props.updateSelection && this.props.updateSelection(context || this.state.context);
  }

  saveSelection(context) {
    this.props.saveSelection(context || this.state.context);
  }

  render() {
    const canSave = this.state.context && this.state.context.ready();
    return (
      <div className="rule-select-popup">
        <CrmSelection
          {...this.props}
          context={this.state.context}
          selectedContextTypeChanged={this.selectedContextTypeChanged}
          selectedValueChanged={this.selectedValueChanged}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.saveSelection()}>
            <CheckIcon color={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(connectToStores(CrmSelectionContainer));
